class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.popup = this;
    this.closeButton = this.querySelector('.newsletter-popup__close');
    this.overlay = this.querySelector('.newsletter-popup__overlay');
    this.copyButton = this.querySelector('#NewsletterPopupCopyButton');
    this.copyFeedback = this.querySelector('#NewsletterPopupCopyFeedback');
    this.promoCode = this.querySelector('#NewsletterPopupPromoCode');
    
    this.SESSION_CLOSED_KEY = 'newsletter_popup_closed_session';
    this.DELAY_TIME = 3000; // 3 seconds
    
    this.init();
  }

  init() {
    // Check if user closed popup in this session
    if (sessionStorage.getItem(this.SESSION_CLOSED_KEY) === 'true') {
      return; // Don't show popup if closed in this session
    }

    // Bind events
    this.bindEvents();

    // Show popup after delay
    setTimeout(() => {
      this.show();
    }, this.DELAY_TIME);
  }

  bindEvents() {
    // Close button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.hide());
    }

    // Close on overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.hide());
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.hasAttribute('open')) {
        this.hide();
      }
    });

    // Copy button
    if (this.copyButton) {
      this.copyButton.addEventListener('click', () => this.copyPromoCode());
    }
  }

  copyPromoCode() {
    const code = this.promoCode ? this.promoCode.textContent.trim() : 'SENDIT';
    
    // Copy to clipboard
    navigator.clipboard.writeText(code).then(() => {
      // Show feedback
      if (this.copyFeedback) {
        this.copyFeedback.style.display = 'block';
      }
      
      if (this.copyButton) {
        this.copyButton.textContent = 'Copied!';
        this.copyButton.classList.add('copied');
      }

      // Hide popup after a short delay
      setTimeout(() => {
        this.hide();
      }, 1500);
    }).catch(err => {
      console.error('Failed to copy:', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = code;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        if (this.copyFeedback) {
          this.copyFeedback.style.display = 'block';
        }
        if (this.copyButton) {
          this.copyButton.textContent = 'Copied!';
          this.copyButton.classList.add('copied');
        }
        setTimeout(() => {
          this.hide();
        }, 1500);
      } catch (err) {
        console.error('Fallback copy failed:', err);
      }
      document.body.removeChild(textArea);
    });
  }

  show() {
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
  }

  hide() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    // Mark as closed in this session (only for this browser session)
    sessionStorage.setItem(this.SESSION_CLOSED_KEY, 'true');
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
